import { EnteSanitarioList } from './../types/index';
import axios from 'axios';
import { EnteSanitario, IdVersion, EnteSanitarioCreateCommand, EnteSanitarioUpdateCommand } from '../types';
import { utilityService } from './common/utility-service';

const baseUrl = '/api/v1/enti-sanitari';

export const getByKey = async (id: number): Promise<EnteSanitario> => {
    return (await axios.get(`${baseUrl}/${id}`)).data;
};

export const getList = async (): Promise<EnteSanitarioList[]> => {
    return (await axios.get(`${baseUrl}`)).data;
};

export const create = async (command: EnteSanitarioCreateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/create`, command)).data;
};

export const update = async (command: EnteSanitarioUpdateCommand): Promise<IdVersion> => {
    return (await axios.post(`${baseUrl}/update`, command)).data;
};

export const remove = async (items: IdVersion[]): Promise<void> => {
    return (await axios.delete(`${baseUrl}/remove?${utilityService.toQueryStringMultiple(items)}`)).data;
};

